export const allRoutes = {
  edit: "/edit",

  dashboard: "/",

  itinerary: "/itinerary",
  itineraryAdd: "/itinerary/add",
  itineraryAddServiceSchedule: "/add-service-schedule",
  itineraryGenerateQuotationDetails: "/generate-quotation-details",

  event: "/event",
  eventAdd: "/event/add",
  serviceType: "/service-type",
  serviceTypeAdd: "/service-type/add",

  suppliers: "/supplier",
  supplierAdd: "/supplier/add",

  services: "/services",
  servicesAdd: "/services/add",

  agency: "/agency",
  agencyAdd: "/agency/add-agency",

  agent: "/agent",
  agentAdd: "/agent/add-agent",

  region: "/region",
  regionAdd: "/region/add",

  termsConditions: "/terms-conditions",
  termsConditionsAdd: "/terms-conditions/add",

  subAdmin: "/sub-admin",
  subAdminAdd: "/sub-admin/add",

  hotels: "/hotels",
  hotelAdd: "/hotels/add",

  ProfileMyAccount: "/profile/my-account",

  faq: "/faq",

  error: "/*",

  eventEdit: "/event/edit",
  eventDetails: "/event/view",
  login: "/login",

  agentUpdate: `/agent/edit`,

  agencyUpdate: `/agency/edit`,

  regionUpdate: `/region/edit`,

  subAdminEdit: "/sub-admin/edit",
  subAdminView: "/sub-admin/view",

  servicesUpdate: `/services/edit`,
  serviceDetails: `/services/view`,

  itineraryEdit: "/itinerary/edit",
  itineraryDetails: "/itinerary/itinerary-details",
  itineraryView: "/itinerary/view",
  messageThread: "/message-thread",

  supplierView: "/supplier/view",
  supplierUpdate: `/supplier/edit`,

  privacyPolicy: "/privacy-policy",
  resetPassword: "/reset-password",

  serviceTypeUpdate: `/service-type/edit`,
  forgotPassword: "/forgot-password",
  ProfileSettings: "/profile/settings",
  termsAndConditions: "/terms-and-conditions",
  termsConditionsView: "/terms-conditions/view",

  termsConditionsUpdate: "/terms-conditions/edit",


  itineraryViewServiceBookingConfirmationDetails: "/itinerary/itinerary-view/service-booking-confirmation-details",
  itinerarySendMessage: "/send-message",
  itinerarySendEmail: "/itinerary/itinerary-view/send-email"
};
